var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    id: "redo_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".redo_svg__cls-1{fill:none;stroke:#292d32;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "redo_svg__rotate-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "redo_svg__Vector",
    className: "redo_svg__cls-1",
    d: "M27.2 16.51a8.642 8.642 0 0 1 1.46 4.81c0 4.78-3.87 8.67-8.66 8.67-4.78 0-8.67-3.87-8.67-8.66 0-4.78 3.87-8.67 8.66-8.67.98 0 1.95.15 2.89.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redo_svg__Vector-2",
    className: "redo_svg__cls-1",
    d: "m21.23 10.01 2.89 3.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "redo_svg__Vector-3",
    className: "redo_svg__cls-1",
    d: "m20.75 15.79 3.37-2.46"
  }))));
};
export default SvgRedo;